import { getFirebaseAnalytics } from './analytics';
import { getFirebaseApp } from './app';

/** Initializes Firebase. */
export async function initFirebase(): Promise<void> {
  await getFirebaseApp();
  await getFirebaseAnalytics();
}
